import { ArrowRightOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import React, { useEffect, useMemo, useRef } from 'react';
import LanguageSelector from '../drawer/LanguageSelector';

const Translate = ({
  value,
  onChange,
  defaultValues,
  fieldNamePrefix = [],
}) => {
  const form = Form.useFormInstance();
  const valueRef = useRef(value);
  valueRef.current = value;
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;
  const fieldNamePrefixRef = useRef(fieldNamePrefix);
  fieldNamePrefixRef.current = fieldNamePrefix;

  // Utiliser la valeur existante ou la valeur par défaut
  const sourceLanguage = useMemo(() => {
    return value?.source_language ?? defaultValues?.sourceLanguage;
  }, [value?.source_language, defaultValues?.sourceLanguage]);
  const destinationLanguage = useMemo(() => {
    return value?.destination_language ?? defaultValues?.destinationLanguage;
  }, [value?.destination_language, defaultValues?.destinationLanguage]);

  useEffect(() => {
    if (!defaultValues?.destinationLanguage) return;
    form.setFieldValue(
      [...fieldNamePrefixRef.current, 'destination_language'],
      defaultValues?.destinationLanguage
    );
    onChangeRef.current({
      ...valueRef.current,
      destination_language: defaultValues?.destinationLanguage,
    });
    // refs (valueRef, onChangeRef, fieldNamePrefixRef) intentionally excluded:
    // this effect must only fire when the destination language itself changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues?.destinationLanguage, form]);

  // Initialiser les params avec les valeurs par défaut au montage
  useEffect(() => {
    const needsSourceInit =
      value?.source_language === undefined && defaultValues?.sourceLanguage;
    const needsDestInit =
      value?.destination_language === undefined &&
      defaultValues?.destinationLanguage;

    if (needsSourceInit || needsDestInit) {
      onChange({
        ...value,
        source_language:
          value?.source_language ?? defaultValues?.sourceLanguage,
        destination_language:
          value?.destination_language ?? defaultValues?.destinationLanguage,
      });
    }
  }, []);

  const handleSourceChange = (sourceLanguage) => {
    onChange({
      ...value,
      source_language: sourceLanguage,
    });
  };

  const handleDestinationChange = (destinationLanguage) => {
    onChange({
      ...value,
      destination_language: destinationLanguage,
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        gap: 12,
      }}
    >
      <div style={{ flex: 1 }}>
        <Form.Item
          label="Langue source"
          name={[...fieldNamePrefix, 'source_language']}
          rules={[
            {
              required: true,
              message: 'Veuillez sélectionner la langue source',
            },
          ]}
          initialValue={sourceLanguage}
        >
          <LanguageSelector onChange={handleSourceChange} />
        </Form.Item>
      </div>

      <ArrowRightOutlined
        style={{ fontSize: 20, color: '#1890ff', marginBottom: 30 }}
      />

      <div style={{ flex: 1 }}>
        <Form.Item
          label="Langue de destination"
          name={[...fieldNamePrefix, 'destination_language']}
          rules={[
            {
              required: true,
              message: 'Veuillez sélectionner la langue de destination',
            },
          ]}
          initialValue={destinationLanguage}
        >
          <LanguageSelector disabled onChange={handleDestinationChange} />
        </Form.Item>
      </div>
    </div>
  );
};

export default Translate;
